import {} from '../../slices/userSlice/userSlice';
import requestApi from 'utils/Request';
import Swal from 'sweetalert2';
import {
  failureAdminLogout,
  failureAdminUserAdd,
  failureAdminUserDelete,
  failureAdminUserList,
  failureAdminUserView,
  failureActivityLogList,
  failureConnectedAccounts,
  failureRemoveConnectedAccount,
  requestAdminLogout,
  requestAdminUserAdd,
  requestAdminUserDelete,
  requestAdminUserList,
  requestAdminUserView,
  requestActivityLogList,
  requestConnectedAccounts,
  requestRemoveConnectedAccount,
  responseAdminLogout,
  responseAdminUserAdd,
  responseAdminUserDelete,
  responseAdminUserList,
  responseAdminUserView,
  responseActivityLogList,
  responseConnectedAccounts,
  responseRemoveConnectedAccount,
} from 'reactRedux/slices/adminUserSlice/adminUserSlice';
import {
  ADMIN_ACTIVITY_LOG,
  ADMIN_LOGOUT,
  ADMINADDUSER,
  ADMINDETAILUSER,
  ADMINUSERDELETE,
  ADMINUSEREDIT,
  ADMINUSERLIST,
  STRIPE_CONNECTED_ACCOUNT_ASSIGN,
  STRIPE_CONNECTED_ACCOUNT_REMOVE,
  STRIPE_CONNECTED_ACCOUNTS,
} from 'utils/StaticApiEndpoints';

//////// User List //////////
export const ListAdminUserData = (payload) => async (dispatch) => {
  try {
    dispatch(requestAdminUserList());
    const res = await requestApi.get(ADMINUSERLIST, { params: payload });
    dispatch(responseAdminUserList(res));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureAdminUserList(error?.message));
  }
};

//////// User Add //////
export const AddAdminUserData = (payload, callback) => async (dispatch) => {
  try {
    dispatch(requestAdminUserAdd());
    const res = await requestApi.post(ADMINADDUSER, payload);
    dispatch(responseAdminUserAdd(res));
    if (typeof callback === 'function') {
      callback(res?.data?.id);
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureAdminUserAdd(error?.message));
  }
};

//////// User Detail /////
export const ViewAdminUserData = (payload) => async (dispatch) => {
  try {
    dispatch(requestAdminUserView());
    const { data } = await requestApi.get(
      `${ADMINDETAILUSER}/${payload?.id}`,
      payload,
    );
    dispatch(responseAdminUserView(data));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureAdminUserView(error?.message));
  }
};

/////// User Edit //////
export const EditAdminUserData =
  (id, payload, callback) => async (dispatch) => {
    try {
      dispatch(requestAdminUserAdd());
      const res = await requestApi.put(`${ADMINUSEREDIT}/${id}`, payload);
      dispatch(responseAdminUserAdd(res));
      if (typeof callback === 'function') {
        callback();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        text: error?.message,
      });
      dispatch(failureAdminUserAdd(error?.message));
    }
  };

/////// Admin User Delete //////
export const DeleteAdminUserData =
  (id, payload, callback) => async (dispatch) => {
    try {
      dispatch(requestAdminUserDelete());
      const res = await requestApi.delete(`${ADMINUSERDELETE}/${id}`, payload);
      dispatch(responseAdminUserDelete(res));
      if (typeof callback === 'function') {
        callback();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        text: error?.message,
      });
      dispatch(failureAdminUserDelete(error?.message));
    }
  };

//////// Activity Log List //////////
export const ListActivityLogData = (payload) => async (dispatch) => {
  try {
    dispatch(requestActivityLogList());
    const res = await requestApi.get(ADMIN_ACTIVITY_LOG, { params: payload });
    dispatch(responseActivityLogList(res));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureActivityLogList(error?.message));
  }
};

//////// Admin User Logout //////
export const LogoutAdminUser = (adminId, callback) => async (dispatch) => {
  try {
    dispatch(requestAdminLogout());
    const res = await requestApi.post(`${ADMIN_LOGOUT}`);
    dispatch(responseAdminLogout(res));
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureAdminLogout(error?.message));
  }
};

//////// Active Stripe Connected Accounts //////
export const GetActiveConnectedAccounts = () => async (dispatch) => {
  try {
    dispatch(requestConnectedAccounts());
    const res = await requestApi.get(STRIPE_CONNECTED_ACCOUNTS);
    dispatch(responseConnectedAccounts(res));
  } catch (error) {
    Swal.fire({ icon: 'error', text: error?.message });
    dispatch(failureConnectedAccounts(error?.message));
  }
};

//////// Remove Connected Account from Dealer //////
export const RemoveConnectedAccount =
  (adminId, callback) => async (dispatch) => {
    try {
      dispatch(requestRemoveConnectedAccount());
      await requestApi.delete(
        `${STRIPE_CONNECTED_ACCOUNT_REMOVE}/${adminId}/assign`,
      );
      dispatch(responseRemoveConnectedAccount());
      if (typeof callback === 'function') {
        callback();
      }
    } catch (error) {
      Swal.fire({ icon: 'error', text: error?.message });
      dispatch(failureRemoveConnectedAccount(error?.message));
    }
  };

//////// Assign Existing Connected Account to Dealer //////
export const AssignConnectedAccount =
  (adminId, connectedAccountId, callback) => async (dispatch) => {
    try {
      dispatch(requestAdminUserAdd());
      const res = await requestApi.patch(
        `${STRIPE_CONNECTED_ACCOUNT_ASSIGN}/${adminId}/assign`,
        { connectedAccountId },
      );
      dispatch(responseAdminUserAdd(res));
      if (typeof callback === 'function') {
        callback();
      }
    } catch (error) {
      Swal.fire({ icon: 'error', text: error?.message });
      dispatch(failureAdminUserAdd(error?.message));
    }
  };
